module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/learn-js/Mehtris/src/app/canvas/canvas.component.html
// module id = ../../../../../src/app/canvas/canvas.component.html
// module chunks = main